import { formsFromConjugation } from './conjugation.js';
export function stripArticle(text) {
    return text.replace(/^(der|die|das)\s+/i, '').trim();
}
/**
 * Every surface form that counts as "known" when a word is marked known:
 * nouns = singular + plural, verbs = all single-word conjugated forms, everything else = itself.
 * Deduplicated case-insensitively; the first-seen casing wins.
 */
export function expandKnownForms(source) {
    const meta = source.linguistic_meta;
    const pos = source.part_of_speech ?? meta?.part_of_speech;
    const candidates = [source.lemma];
    if (pos === 'noun' && meta?.plural) {
        candidates.push(stripArticle(meta.plural));
    }
    else if (pos === 'verb' && meta?.conjugation) {
        candidates.push(...formsFromConjugation(source.lemma, meta.conjugation, source.separable));
    }
    const seen = new Set();
    const result = [];
    for (const form of candidates) {
        const key = form.trim().toLowerCase();
        if (!key || seen.has(key))
            continue;
        seen.add(key);
        result.push(form.trim());
    }
    return result;
}
